// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class FeaturesCarousel extends HTMLElement {
  constructor () {
    super()

    this.hotspotEls = this.querySelectorAll('[data-el-hotspot]')
    this.hotspotPointEls = this.querySelectorAll('[data-el-hotspot-point][data-el-hotspot]')
    this.carouselEl = this.querySelector('[data-el="features-carousel"]')
    this.slidesEl = this.querySelector('[data-el="features-carousel.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="features-carousel.slide"]')
    this.dotEls = this.querySelectorAll('[data-el="features-carousel.dot"]')
    this.arrowNextEls = this.querySelectorAll(
      '[data-el="features-carousel.controlnext"]'
    )
    this.arrowPrevEls = this.querySelectorAll(
      '[data-el="features-carousel.controlprevious"]'
    )

    this.ignoreCarousel = window.matchMedia('(min-width: 640px)')

    if (!this.ignoreCarousel.matches) {
      this.carousel = this.initialiseCarousel()
    }

    if (this.slideEls.length < 2) return
    this.addListeners()
  }

  addListeners () {
    this.arrowNextEls.forEach(arrowNextEl => {
      arrowNextEl.addEventListener('click', this.changeCarousel.bind(this))
    })
    this.arrowPrevEls.forEach(arrowPrevEl => {
      arrowPrevEl.addEventListener('click', this.changeCarousel.bind(this))
    })

    this.hotspotEls.forEach(hotspotEl => {
      hotspotEl.addEventListener('mouseenter', this.addActive.bind(this))
      hotspotEl.addEventListener('click', this.addActive.bind(this))
    })

    this.hotspotPointEls.forEach(hotspotPointEl => {
      hotspotPointEl.addEventListener('click', this.handlePointClick.bind(this))
    })

    this.handleWindowResize = this.handleWindowResize.bind(this)
    window.addEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize () {
    if (this.carousel) {
      this.carousel.destroy()
    }

    if (!this.ignoreCarousel.matches) {
      this.carousel = this.initialiseCarousel()
    }
  }

  slideTo (slide) {
    this.carousel.moveToSlide(slide)
  }

  removeActives () {
    this.hotspotEls.forEach(hotspotEl => {
      hotspotEl.removeAttribute('data-active')
    })
  }

  addActive (choice) {
    this.removeActives()
    this.choice = choice.currentTarget.dataset.elHotspot
    this.chosenHotspot = this.querySelectorAll(
      `[data-el-hotspot="${this.choice}"]`
    )

    this.chosenHotspot.forEach(hotspot => {
      hotspot.setAttribute('data-active', true)
    })

    if (!this.ignoreCarousel.matches) {
      this.slideTo(this.choice)
    }
  }

  handlePointClick (e) {
    // Mobile viewport only
    const tabletMediaQuery = window.matchMedia('(min-width: 640px) and (max-width: 900px)')
    if (!tabletMediaQuery.matches) {
      return
    }

    // Check if relative block is in viewport, if not, scroll into view
    const hotspotIndex = e.currentTarget.dataset.elHotspot
    const relativeBlock = this.querySelector(`[data-el-hotspot-block][data-el-hotspot="${hotspotIndex}"]`)
    if (relativeBlock) relativeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 1000,
      centered: false,
      loop: true,
      mode: 'snap',
      slides: '.car-Carousel_Slide',
      slidesPerView: 1,
      slideChanged: instance => {
        this.dotEls.forEach(dot => {
          dot.setAttribute(
            'aria-current',
            parseInt(dot.dataset.slide) === instance.details().relativeSlide
          )
        })
      },
      afterChange: instance => {
        this.removeActives()
        this.chosenHotspot = this.querySelectorAll(
          `[data-el-hotspot="${instance.details().relativeSlide}"]`
        )
        this.chosenHotspot.forEach(hotspot => {
          hotspot.setAttribute('data-active', true)
        })
      },
    })
  }

  changeCarousel (e) {
    if (e.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('features-carousel', FeaturesCarousel)
